var chunkToChildrenMap = {
	"1874": [
		222
	],
	"1952": [
		7869
	],
	"2744": [
		8886
	],
	"3290": [
		7853,
		5087
	],
	"3498": [
		4957
	],
	"3521": [
		9125
	],
	"4672": [
		6177
	],
	"4896": [
		8347
	],
	"7069": [
		9686
	],
	"7606": [
		8886,
		6822
	],
	"8347": [
		7434
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));